import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tax } from '../pages/admin/tax-collection/tax';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  private baseURL = `${environment.apiBaseUrl}/api/taxCollection/`;

  constructor(private httpClient: HttpClient) {}

  getTaxList = (assessment_qr_code: string): Observable<any> => {
    console.log(assessment_qr_code);
    return this.httpClient.post(`${this.baseURL}getTaxCollectionListByQrCode`, {
      assessment_qr_code,
    });
  };

  private doPost = (
    paramObject: any,
    body: any,
    location: string
  ): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.post<any>(url, body);
  };

  debitOrCreditSingleAssessment = (tax: Tax): Observable<any> => {
    return this.doPost({}, tax, 'debitOrCreditSingleAssessment');
  };

  deleteTaxCollection = async (taxId: number) => {
    return this.httpClient.delete<any>(`${this.baseURL}delete/${taxId}`);
  };

  bulkTaxCollectionFromExcel = (payload: any): Observable<any> => {
    return this.doPost({}, payload, 'bulkTaxCollectionFromExcel');
  };
}
